// ---------------------------------------------------------------------------
// MixAI — ค่าคงที่/ENV (REACT_APP_* ถูกฝังลง bundle ห้ามใส่ secret)
// ---------------------------------------------------------------------------
export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.swiftgoldpay.com/api/";

// Firebase Realtime Database (REST) — หน้าเว็บอ่าน/เขียนตรง ไม่มี server (แบบเดียวกับ AITalk)
export const FB_URL = (process.env.REACT_APP_FIREBASE_URL || "").trim().replace(/\/+$/, "");
export const FB_ROOT = (process.env.REACT_APP_FIREBASE_ROOT || "").trim().replace(/^\/+|\/+$/g, "");

/** ไม่ตั้ง FIREBASE_URL หรือสั่ง REACT_APP_USE_MOCK=true -> โหมดทดลอง (localStorage, ไม่ยิงเน็ต) */
export const IS_MOCK = process.env.REACT_APP_USE_MOCK === "true" || !FB_URL;
export const MOCK_PREFIX = "mixai";

export const TOKEN_KEY = "mixai-tk";
export const PROFILE_KEY = "mixai-profile";
export const AUTH_EVENT = "mixai-auth-change";
export const THEME_KEY = "mixai:theme";

export const USER_TYPE = { user: "customer", superUser: "super_user" };

export const PROCESS_TYPE = "mixai";
export const ORDER_TYPE = { subscription: "mixai_subscription", tokens: "mixai_token_pack" };

export const PARTNER = {
  clientId: process.env.REACT_APP_CLIENT_ID || "",
  clientSecret: process.env.REACT_APP_CLIENT_SECRET || "",
  clientRefId: process.env.REACT_APP_CLIENT_REF_ID || "",
  apigwApiId: process.env.REACT_APP_X_APIGW_API_ID || "",
  customerIdDefault: process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "",
  currency: "THB",
};

export const CAPTCHA = {
  siteKey: process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "",
  masterToken: process.env.REACT_APP_CAPTCHA_TOKEN_MASTER || "",
};

export const QR_EXPIRE_SECONDS = 600;
export const QR_POLL_MS = 5000;
export const QR_INQUIRY_MS = 20000;

export const ENDPOINTS = {
  login: "v1/public/market/login",
  logout: "v1/public/market/logout",
  register: "v1/public/market/customer",
  resetPassword: "v1/public/reset-password",
  profile: "v1/market/profile",
  depositPartner: "transactions/deposits/partner",
  depositGetById: "transactions/deposits/public/get-by-id",
  inquiry: "transactions/inquiry",
};
